export const DB_CONFIG = {
    apiKey: "AIzaSyC49rog5hpDS1dLn5rsX9tC7PBKPhwiqDM",
    authDomain: "esp32-3493d.firebaseapp.com",
    databaseURL: "https://esp32-3493d.firebaseio.com",
    projectId: "esp32-3493d",
    storageBucket: "esp32-3493d.appspot.com",
    messagingSenderId: "617581612432"
}


// WEBPACK FOOTER //
// ./src/config/config.js